var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row",
      class: [_vm.description ? "tooltip-mine-dynamic" : "tooltip-mine"]
    },
    [
      !_vm.description
        ? _c("div", { staticClass: "col-lg-1 col-2 cursor-pointer d-table" }, [
            _c(
              "span",
              {
                staticClass: "icon-prev d-table-cell align-middle",
                on: {
                  click: function($event) {
                    return _vm.goPrevious()
                  }
                }
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "cursor-pointer",
                  attrs: { icon: ["fas", "angle-left"] }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.description
        ? _c("div", { staticClass: "col img-info" }, [
            _c("img", {
              staticClass: "border-img",
              attrs: {
                src: _vm.baseImageUrl + _vm.data[_vm.index].image,
                height: "40",
                width: "40"
              }
            }),
            _c("p", { staticClass: "jewel-descr text-uppercase" }, [
              _vm._v(_vm._s(_vm.$t(_vm.type + "-information")))
            ]),
            _vm.data[_vm.index].description
              ? _c("span", { staticClass: "jewel-descr" }, [
                  _vm._v(_vm._s(_vm.data[_vm.index].description))
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm.description
        ? _c("div", { staticClass: "col img-info d-table" }, [
            _c(
              "span",
              { staticClass: "jewel-descr d-table-cell align-middle" },
              [_vm._v(_vm._s(_vm.description))]
            )
          ])
        : _vm._e(),
      !_vm.description
        ? _c("div", { staticClass: "col-lg-1 col-2 cursor-pointer d-table" }, [
            _c(
              "span",
              {
                staticClass: "icon-next d-table-cell align-middle",
                on: {
                  click: function($event) {
                    return _vm.goNext()
                  }
                }
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "cursor-pointer",
                  attrs: { icon: ["fas", "angle-right"] }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }